function levenshtein(a: string, b: string): number {
  const m = a.length, n = b.length;
  if (m === 0) return n;
  if (n === 0) return m;
  const dp = new Array(n + 1);
  for (let j = 0; j <= n; j++) dp[j] = j;
  for (let i = 1; i <= m; i++) {
    let prev = dp[0];
    dp[0] = i;
    for (let j = 1; j <= n; j++) {
      const tmp = dp[j];
      dp[j] = a[i - 1] === b[j - 1] ? prev : 1 + Math.min(prev, dp[j], dp[j - 1]);
      prev = tmp;
    }
  }
  return dp[n];
}

// Longer words tolerate more typos before we stop treating them as a match.
function fuzzyThreshold(len: number): number {
  if (len <= 3) return 0;
  if (len <= 5) return 1;
  return 2;
}

function tokenScore(token: string, words: string[]): number | null {
  let best: number | null = null;
  for (const w of words) {
    if (w === token) return 0;
    if (w.includes(token) || token.includes(w)) {
      if (best === null || best > 0.5) best = 0.5;
      continue;
    }
    const dist = levenshtein(token, w);
    if (dist <= fuzzyThreshold(token.length)) {
      const scored = dist + 1;
      if (best === null || scored < best) best = scored;
    }
  }
  return best;
}

/**
 * Scores a category label/group against a free-text query. Each query word must
 * match some word in the label/group either as a substring or within a small
 * edit-distance (to tolerate typos) — lower score is a better match, null means no match.
 */
export function matchLabel(query: string, label: string, group?: string): number | null {
  const tokens = query.trim().toLowerCase().split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return 0;
  const words = `${label} ${group ?? ""}`.toLowerCase().split(/[\s,/()-]+/).filter((w) => w.length >= 3);
  let total = 0;
  for (const token of tokens) {
    const score = tokenScore(token, words);
    if (score === null) return null;
    total += score;
  }
  return total;
}
